import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Button from '@mui/material/Button';
import { PillButton, ControlledTextField } from '@zz2/zz2-ui';
import { ControlledLabelledCheckBox } from '../../../../components/input/form/ControlledLabelledCheckBoxWrapper';
import { yupResolver } from '@hookform/resolvers/yup';
import { ICarrierFormValues } from '../../../../@types/model/masterData/carrier/carrierFormValues';
import CarrierModelHelper from '../../../../@types/model/masterData/carrier/carrierModelHelper';
import CustomReactHookFormDevTools from '../../../../components/devtools/ReactHookFormDevTools';

interface ICarrierFormProps {
    isLoading : boolean;
    initialValues : ICarrierFormValues;
    onSubmit : (values : ICarrierFormValues) => void;
    onClose : () => void;
}

const CarrierForm = (props : ICarrierFormProps) : React.ReactElement => {
    const { handleSubmit, control, formState: { isValid, isDirty }, trigger } = useForm<ICarrierFormValues>({
        defaultValues: props.initialValues,
        resolver: yupResolver(CarrierModelHelper.formSchema()),
        mode: 'onChange',
    });

    /*================================================================================================================
     *                                                  Effects
     * ==============================================================================================================*/

    useEffect(() => {
        trigger();
    }, []);

    /*================================================================================================================
     *                                                  Async Methods
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Handler Methods
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Memos
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Render Methods
     * ==============================================================================================================*/

    return (
        <div>
            <form onSubmit={handleSubmit(props.onSubmit)}>
                <div className={'fdc p20 pt15 pb10'}>
                    <ControlledTextField
                        className={'mb10'}
                        control={control}
                        label={'Code'}
                        name={'code'}
                        defaultValue={props.initialValues.code}
                        size={'small'}
                    />
                    <ControlledTextField
                        className={'mb20'}
                        control={control}
                        label={'Name'}
                        name={'name'}
                        defaultValue={props.initialValues.name}
                        size={'small'}
                    />
                    <div className={'flx1 fdr jcfs'}>
                        <ControlledLabelledCheckBox
                            label={'Active?'}
                            name={'isActive'}
                            control={control}
                            defaultValue={props.initialValues.isActive}
                            disabled={props.initialValues.isActive}
                        />
                    </div>
                    <div className={'fdr flx1 aic jcfe'}>
                        <Button className={'cpd mr20'} type={'button'} onClick={props.onClose}>
                            CANCEL
                        </Button>
                        <PillButton
                            className={'pl30 pr30'}
                            text={'SAVE'}
                            size={'small'}
                            type={'submit'}
                            color={'secondary'}
                            disabled={ !isDirty || !isValid || props.isLoading }
                        />
                    </div>
                </div>
            </form>
            <CustomReactHookFormDevTools control={control} />
        </div>
    );
};

export default CarrierForm;
